import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { withNamespaces } from "react-i18next";

import WhiteButton from "../form_components/Buttons/WhiteButton/WhiteButton";

function MainCompaniesEditBox({
  t,
  mainCompanyStatus,

  searchText,
  setSearchText,

  tableFilter,
  setTableFilter,

  useFetchRender,
  setUseFetchRender,

  selectValueId,
  setSelectValueId,

  selectValue,
  setSelectValue,

  handleOpenDeleteModal,
  handleOpenAddMainCompanyModal,
}) {
  const [isSearchOpen, setSearchOpen] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setSearchOpen(false);
    }
  };

  /* process => Yapılacak işlem (düzenle,sil,..) */
  function handleClick(process) {
    switch (process) {
      case "render":
        console.log("Tablo yenilendi!");

        setUseFetchRender(!useFetchRender);

        setSearchOpen(false);

        setSelectValueId(null);
        setSelectValue(null);

        break;

      case "search":
        console.log("Bul a tıklandı!");
        // alert("Bul a tıklandı!");

        setSearchOpen(true);

        break;

      case "add-my-maincompany":
        console.log("add-my-maincompany a tıklandı!");

        handleOpenAddMainCompanyModal();

        setSearchOpen(false);

        break;

      case "delete":
        console.log("delete  tıklandı!");

        handleOpenDeleteModal();

        setSearchOpen(false);

        break;

      default:
        break;
    }
  }

  return (
    <div className="edit-container">
      <div className="edit-box">
        <div className="edit-container-title">
          <h4 className="title">
            {" "}
            <i className="fa-solid fa-star" /> {t("my_maincompanies_title")}
          </h4>
        </div>

        <div className="edit-container-button-group">
          <WhiteButton
            icon={<i className="fa-solid fa-arrow-rotate-right" />}
            tooltip={t("button_edit_render")}
            onClick={() => handleClick("render")}
          />

          <WhiteButton
            icon={
              isSearchOpen ? (
                <div ref={searchRef} className="search-container">
                  <i className="fa-solid fa-magnifying-glass" />
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              ) : (
                <i className="fa-solid fa-magnifying-glass" />
              )
            }
            tooltip={t("button_edit_search")}
            onClick={() => handleClick("search")}
          />

          <Link
            to={
              selectValueId || selectValue
                ? `company-profile/${selectValueId}`
                : false
            }
          >
            <WhiteButton
              icon={<i className="fa-solid fa-info" />}
              tooltip={t("button_edit_detail")}
              disabled={selectValueId || selectValue ? false : true}
            />
          </Link>

          {mainCompanyStatus === "Tavsiye Edilenler" ? (
            <WhiteButton
              icon={<i className="fa-solid fa-user-plus"></i>}
              tooltip={t("button_add_maincompany")}
              onClick={() => handleClick("add-my-maincompany")}
              disabled={selectValueId || selectValue ? false : true}
            />
          ) : (
            <>
              <WhiteButton
                icon={<i className="fa-solid fa-trash-can"></i>}
                tooltip={t("button_delete_maincompany")}
                onClick={() => handleClick("delete")}
                disabled={selectValueId || selectValue ? false : true}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default withNamespaces()(MainCompaniesEditBox);
